import React from 'react';
import { Button, Box, Tooltip, CircularProgress } from '@mui/material';
import { RiFileExcel2Line } from "react-icons/ri"; // Import the Excel icon

const ExportToExcelButton = ({ onClick, disabled = false }) => {
  return (
    <Tooltip title="Export To Excel" arrow>
      <Box display="flex" justifyContent="center" alignItems="center"> {/* Center the button */}
        <Button
          variant="contained"
          color="success"
          startIcon={disabled ? <CircularProgress size={20} color="inherit" /> : <RiFileExcel2Line />} // Show loading icon when disabled
          onClick={onClick}
          size="small"
          disabled={disabled}
        >
          {disabled ? 'Loading' : 'Export'} {/* Change button text */}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default ExportToExcelButton;
